import { Divider, Typography, List, Box } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import { Formik } from "formik"
import { validationSchemaEditContest } from "helpers/validationSchema"
import React, { useEffect, useRef } from "react"
import { Fragment } from "react"
import { useTheme } from "@mui/system"
import Header from "components/Header/Header"
import { Container, Row, Col } from "react-bootstrap"
import AppDatePicker from "components/AppDatePicker"
import { useHistory } from "react-router-dom"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import AppSelect from "components/StyledComponents/AppSelect"
import moment from "moment"
import StyledLabel from "components/StyledComponents/StyledLabel"
import { COINS, initialValue } from "helpers/constant"
import {
  editWeeklyQuizAction,
  getViewQuizQuestionsAction,
  updateQuizQuestionsAction,
  viewWeeklyQuizAction
} from "redux/marketing/actions"
import WeeklyQuizQuestions from "../components/ContestDetails/WeeklyQuizQuestions"

function EditWeeklyQuiz() {
  const theme = useTheme()
  const history = useHistory()
  const dispatch = useDispatch()
  const statusRef = useRef("Pending")
  const { weeklyQuizData, quizQuestions, quizQuestionsCount } = useSelector(
    (store) => store?.marketing
  )
  const [initialValues, setInitialValues] = useState(initialValue)
  const [breadCrumbs, setBreadcrumbs] = useState([])

  const styles = {
    heading: {
      color: theme.palette.text.secondary
    },
    btn: {
      padding: "13px 48px"
    },
    required: {
      color: theme.palette.error.main
    }
  }

  const handleSaveAsDraft = ({ handleSubmit }) => {
    statusRef.current = "Draft"
    handleSubmit()
  }

  const handlePublish = ({ handleSubmit }) => {
    statusRef.current = "Published"
    handleSubmit()
  }

  const handleShuffleQuestions = () => {
    dispatch(updateQuizQuestionsAction({ quizId: weeklyQuizData?.id }))
  }

  const handleSubmit = (values) => {
    const payload = {
      quiz_coins: values?.quiz_coins,
      ...(statusRef.current !== "AddQuestions" ? { status: statusRef.current.toUpperCase() } : {})
    }

    dispatch(
      editWeeklyQuizAction({
        payload,
        handleRoute: () =>
          history.push("/learning_development/dashboard/weekly-challenge/weekly-quiz")
      })
    )
  }

  const checkStatus = () => {
    if (weeklyQuizData?.status?.toLowerCase() === "published") {
      return new Date(weeklyQuizData?.start_date) > new Date()
    }
    return true
  }

  const alertUser = (e) => {
    e.preventDefault()
    e.returnValue = ""
  }

  useEffect(() => {
    const {
      name,
      created_by,
      start_date,
      end_date,
      creation_date,
      published_week_day,
      quiz_coins
    } = {
      ...(weeklyQuizData ?? {})
    }
    setInitialValues({
      name,
      scope: "All Restaurant",
      created_by,
      published_week_day,
      start_date: moment(start_date).utc(),
      end_date: moment(end_date).utc(),
      creation_date: moment(creation_date).utc(),
      quiz_coins: quiz_coins
    })
  }, [weeklyQuizData])

  useEffect(() => {
    setBreadcrumbs(createBreadcrumbs())
    document.title = "Weekly Quiz"
    dispatch(viewWeeklyQuizAction())
    dispatch(getViewQuizQuestionsAction())
  }, [])

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser)
    return () => {
      window.removeEventListener("beforeunload", alertUser)
    }
  }, [])

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}
        validationSchema={validationSchemaEditContest}>
        {(formik) => (
          <Fragment>
            <Container fluid>
              <Row>
                <Col lg="12">
                  <Header title="Weekly Quiz" breadCrumbs={breadCrumbs}>
                    {checkStatus() ? (
                      <Typography
                        variant="body1Regular"
                        onClick={() => handleSaveAsDraft(formik)}
                        sx={{
                          color: theme.palette.secondary.main,
                          textDecoration: "underline",
                          margin: "13px 50px",
                          cursor: "pointer",
                          textUnderlineOffset: "2px"
                        }}>
                        Save Draft
                      </Typography>
                    ) : null}
                    <AppButton onClick={() => handlePublish(formik)} styles={styles.btn}>
                      Publish
                    </AppButton>
                  </Header>
                </Col>
              </Row>
            </Container>

            <Container fluid>
              <Row>
                <Col lg="4">
                  <AppTextField
                    id="name"
                    name="name"
                    fullWidth
                    label="Contest Name"
                    isRequired={true}
                    isUpperCase={true}
                    disabled={true}
                    placeholder="Enter Contest Name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Col>
                <Col lg="4">
                  <List sx={{ padding: 0 }}>
                    <Box>
                      <Typography variant="body1Regular" sx={styles.heading}>
                        Duration
                      </Typography>
                      <span style={styles.required}>*</span>
                    </Box>
                    <Box sx={{ display: "flex", marginTop: "5px" }} className="datesContainer">
                      <Col lg="6" className="me-2 dateFieldContainer">
                        <AppDatePicker
                          views={["year", "month"]}
                          inputFormat="MMM yyyy"
                          key={"start_date"}
                          disabled={true}
                          value={formik.values.start_date}
                          minDate={new Date()}
                          onChange={(val) => formik.setFieldValue("start_date", val)}
                        />
                      </Col>
                    </Box>
                  </List>
                </Col>
                <Col lg="4">
                  <StyledLabel variant="body1Regular">
                    Quiz coins per question <span>*</span>
                  </StyledLabel>
                  <Col lg="12" md="10" className="mt-1">
                    <AppSelect
                      id="quiz_coins"
                      name="quiz_coins"
                      isRequired={true}
                      menuItems={COINS}
                      value={formik.values.quiz_coins}
                      onChange={formik.handleChange}
                      error={formik.errors.quiz_coins}
                      touched={formik.touched.quiz_coins}
                    />
                  </Col>
                </Col>
              </Row>
              <Divider className="mt-4"></Divider>
            </Container>
            <Container fluid className="mt-4 ">
              <Row>
                <Col lg="4" style={{ paddingRight: 12 }}>
                  <Box>
                    <List sx={{ padding: 0 }}>
                      <Box className="pb-1">
                        <Typography variant="body1Regular" sx={styles.heading}>
                          Creation Date
                        </Typography>
                        <span style={styles.required}>*</span>
                      </Box>
                      <Box sx={{ display: "flex", marginTop: "5px" }} className="datesContainer">
                        <Col lg="12" className="dateFieldContainer">
                          <AppDatePicker
                            key="creation_date"
                            disabled
                            value={formik.values.creation_date}
                            onChange={(val) => formik.setFieldValue("creation_date", val)}
                            error={formik.errors.creation_date}
                            touched={formik.touched.creation_date}
                          />
                        </Col>
                      </Box>
                    </List>
                  </Box>
                </Col>
                <Col lg="4">
                  <AppTextField
                    id="created_by"
                    name="created_by"
                    fullWidth
                    label="Created By"
                    isDisabled={true}
                    isUpperCase={true}
                    placeholder="Enter Created By"
                    value={formik.values.created_by}
                    onChange={formik.handleChange}
                    error={formik.touched.created_by && Boolean(formik.errors.created_by)}
                    helperText={formik.touched.created_by && formik.errors.created_by}
                  />
                </Col>
              </Row>
              <Divider className="mt-4"></Divider>
            </Container>
            {weeklyQuizData?.status?.toLowerCase() !== "published" && (
              <Container fluid className="mt-4">
                <Row>
                  <Col lg="12" className="d-flex justify-content-between">
                    <Typography variant="h2">Questions</Typography>
                    <Col className="d-flex justify-content-end gap-4">
                      <AppButton onClick={handleShuffleQuestions} styles={styles.btn}>
                        Update Questions
                      </AppButton>
                    </Col>
                  </Col>
                </Row>
              </Container>
            )}
          </Fragment>
        )}
      </Formik>
      <Row className="px-4">
        <WeeklyQuizQuestions questions={quizQuestions} questionCount={quizQuestionsCount} />
      </Row>
    </Fragment>
  )
}

export default EditWeeklyQuiz
